import storage from "@/store/storage";
import $req from "@/util/req";
import $router from "@/router/index";
import * as $WBT from "@/util/websocket";

//工具类方法的配置
import { Notification } from "element-ui";

//日期格式化
let timeUtil = {
  formatYMD: function(date) {
    return date.Format("YYYY-MM-dd");
  },
  formatYM: function(date) {
    return date.Format("YYYY-MM");
  },
  formatY: function(date) {
    return date.Format("YYYY");
  },
  format: function(date) {
    return date.Format("YYYY-MM-dd HH:mm:ss");
  },
  ios: function(datestr) {
    return datestr.replace(/-/g, "/");
  }
};

//提示信息封装
let _notify = {
  success: function(message, duration) {
    Notification.success({
      title: "成功",
      message: message,
      duration: duration || 3000
    });
  },
  warning: function(message, duration) {
    Notification.warning({
      title: "提醒",
      message: message,
      duration: duration || 3000
    });
  },
  error: function(message, reason, duration) {
    Notification.error({
      title: "错误",
      message: `${message ? message : reason}`,
      duration: duration || 3000
    });
  },
  holdMsg: function(message) {
    Notification.info({
      title: "提示",
      message: message,
      duration: 0
    });
  }
};

//token失效
let tokenInvalid = function() {
  $WBT.initWs.isReconnect = false;
  storage.removeUser();
  storage.removeDict();
  storage.delToken();
  storage.removeMenus();
  storage.setLoginState(false);
  $router.push({
    path: "/login"
  });
};

//表单请求
let req_post = function(param, url, callback) {
  var token = storage.getToken();
  if (!storage.getLoginState() || token) {
    $req.post(
      param,
      url,
      function(_r, _x) {
        if (_r.success) {
          callback(_r);
        } else {
          _notify.warning(_r.message);
        }
      },
      function error(e) {
        if (e.code == 408) {
          tokenInvalid();
        } else {
          var msg = e.message ? e.message : e.msg ? e.msg : e.reason;
          _notify.error(JSON.stringify(msg));
        }
      }
    );
  } else {
    _notify.warning("当前 平台凭证 验证失败！", 5000);
    tokenInvalid();
  }
};

// 收运计划 表单请求
let req_post_detailsref = function(param, url, callback) {
  var token = storage.getToken();
  if (!storage.getLoginState() || token) {
    $req.post(
      param,
      url,
      function(_r, _x) {
        if (_r.success) {
          callback(_r);
        } else {
          _notify.warning(_r.message);
        }
      },
      function error(e) {
        if (e.code == 408) {
          tokenInvalid();
        } else {
          var msg = e.message ? e.message : e.msg ? e.msg : e.reason;
          _notify.warning(JSON.stringify(msg));
        }
      }
    );
  } else {
    _notify.warning("当前 平台凭证 验证失败！", 5000);
    tokenInvalid();
  }
};

//数字转汉字
let toChinesNum = num => {
  let changeNum = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  let unit = ["", "十", "百", "千", "万"];
  num = parseInt(num);
  let getWan = temp => {
    let strArr = temp
      .toString()
      .split("")
      .reverse();
    let newNum = "";
    for (var i = 0; i < strArr.length; i++) {
      newNum =
        (i == 0 && strArr[i] == 0
          ? ""
          : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
          ? ""
          : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
        newNum;
    }
    return newNum;
  };
  let overWan = Math.floor(num / 10000);
  let noWan = num % 10000;
  if (noWan.toString().length < 4) {
    noWan = "0" + noWan;
  }
  return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
};

//表单请求
let req_ajax = function(that, options) {
  that.$req.ajax(
    options,
    function(_r, _x) {
      if (_r.success) {
        callback(_r);
      } else {
        _notify.success(_r.message);
      }
    },
    function error(e) {
      _notify.error(JSON.stringify(e.message, e.reason));
    }
  );
};

//提交请求的统一处理
let _formPost = function(isValid, that, _ref, param, url, callback) {
  if (isValid) {
    //是否校验表单
    that.$refs[_ref].validate(valid => {
      if (valid) {
        req_post(param, url, function(_r) {
          callback(_r);
        });
      } else {
        _notify.warning("表单校验失败，请按提示修改");
      }
    });
  } else {
    req_post(param, url, function(_r) {
      callback(_r);
    });
  }
};

//表单校验
let _validForm = {
  telPhone: /^(((0\d{2,3})-)(\d{7,8})(-(\d{3,4}))?|(1[35678]\d{9})|([0-9]{3,4})?(-)?[0-9]{7})$/, //手机号/电话号校验
  idCard: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/, //身份证校验
  serverAddress: /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/, //服务器地址
  nonnegativeInt: /^[1-9]\d*|0$/, //非负整数
  monnegativeNumber: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d{1,2})$/, //非负数
  positiveNumber: /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/, ///正数
  positiveInt: /^[0-9]*[1-9][0-9]*$/, //正整数
  plateNumber: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/ //车牌号校验
};

//表单校验提示信息
let rulesMsg = {
  positiveNumber: "请输入大于0的数字(保留两位小数)",
  monnegativeNumber: "请输入大于等于0的数字(保留两位小数)",
  positiveInt: "请输入正整数",
  serverAddress: "请输入合法的服务器地址",
  nonnegativeInt: "请输入大于等于0的整数",
  idCard: "请输入正确格式的身份证号",
  telPhone: "请输入正确格式的手机号/电话",
  plateNumber: "车牌号格式不正确"
};

//克隆
let clone_str = function(obj) {
  var o;
  switch (typeof obj) {
    case "undefined":
      break;
    case "string":
      o = obj + "";
      break;
    case "number":
      o = obj - 0;
      break;
    case "boolean":
      o = obj;
      break;
    case "object":
      if (obj === null) {
        o = "";
      } else {
        if (obj instanceof Array) {
          o = [];
          for (var i = 0, len = obj.length; i < len; i++) {
            o.push(this.clone_str(obj[i]));
          }
        } else {
          o = {};
          for (var k in obj) {
            if (obj[k] instanceof Array) {
              o[k] = this.clone_str([]);
            } else {
              o[k] = this.clone_str(obj[k]);
            }
          }
        }
      }
      break;
    default:
      o = obj;
      break;
  }
  return o;
};

//表单重置
let formReset = function(formParam) {
  Object.keys(formParam).forEach(function(key) {
    // 可进行逻辑判断，或者重新赋值
    if (typeof formParam[key] == "string") {
      formParam[key] = "";
    } else if (typeof formParam[key] == "number") {
      formParam[key] = "";
    } else {
      formParam[key] = [];
    }
  });
};

//构造表单formParam表单的参数，formParamDefault表单默认参数,exclude排除的参数
let formData = function(formParam, formParamDefault, exclude) {
  var excludeParam = exclude ? exclude : "";
  var param = new FormData();
  excludeParam = excludeParam.split(",");
  for (let key in formParam) {
    for (let k in formParamDefault) {
      if (key == k) {
        var flag = true; //判断是否是排除的参数
        excludeParam.forEach(e => {
          if (e == key) {
            flag = false;
          }
        });
        if (flag) {
          param.append(key, formParam[key]);
        }
      }
    }
  }

  return param;
};

//时间格式化
let dateFormat = function(fmt, date) {
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
};

//时间戳转时间类型
let getTime = function(data, type) {
  var _data = data;
  //如果是13位正常，如果是10位则需要转化为毫秒
  if (String(data).length == 13) {
    _data = data;
  } else {
    _data = data * 1000;
  }
  const time = new Date(_data);
  const Y = time.getFullYear();
  const Mon = time.getMonth() + 1;
  const Day = time.getDate();
  const H = time.getHours();
  const Min = time.getMinutes();
  const S = time.getSeconds();
  //自定义选择想要返回的类型
  if (type == "Y") {
    return `${Y}-${Mon}-${Day}`;
  } else if (type == "H") {
    return `${H}:${Min}:${S}`;
  } else {
    return `${Y}-${Mon}-${Day} ${H}:${Min}:${S}`;
  }
};

//字符串转时间类型
let stringToData = function(val) {
  var v = val.replace(/-/g, "/");
  return new Date(v);
};

//控制按钮显隐power：按钮权限code
let btnShow = function(power) {
  let menus = storage.getUser().powers;
  var flag = false;
  menus.forEach(e => {
    if (e == power) {
      flag = true;
    }
  });
  return flag;
};

/**
 * @description: 处理数字小数点
 * @param {number} num
 * @param {number} useDecimal
 * @return {string}
 */
const handleDecimal = (num = 0, useDecimal) => {
  let result = num.toString();
  // 如果是证书并且不适应小数
  if (!result.match(/\./) && !useDecimal) return result;
  if (!useDecimal) return Number(result).toFixed(2);
  return Number(result).toFixed(useDecimal);
};

export {
  timeUtil,
  _notify,
  _formPost,
  _validForm,
  clone_str,
  formReset,
  formData,
  dateFormat,
  req_post,
  req_post_detailsref,
  btnShow,
  rulesMsg,
  stringToData,
  req_ajax,
  toChinesNum,
  getTime,
  handleDecimal
};



// WEBPACK FOOTER //
// ./src/util/util.js